module.exports = __webpack_public_path__ + "static/media/services5.93ff157a.png";